import {Service} from "angular-ecmascript/module-helpers";

export let Name = 'bookingColorSelectionModal';

export default class BookingColorSelectionModal extends Service {
    static $name = Name;
    static $inject = ['$q', '$rootScope', '$ionicPopup', '$translate'];

    show(options) {
        var popup = null;
        let defer = this.$q.defer();

        let scope = this.$rootScope.$new(true);
        scope.$color = options.color;
        scope.$colorCols = options.colorCols;
        scope.$colorRowClass = options.colorRowClass;
        scope.$colorColClass = options.colorColClass;

        scope.$selectColor = (color)=> {
            defer.resolve(color);
            popup.close();
        };

        this.$translate([
            'COLOR_LABEL',
            'CANCEL'

        ]).then((translations) => {
            popup = this.$ionicPopup.show({
                template: '<booking-color-selection color="$color" color-cols="$colorCols" color-col-class="$colorRowClass" color-row-class="$colorColClass" on-color-selected="$selectColor(color)"></booking-color-selection>',
                title: translations.COLOR_LABEL,
                scope: scope,
                buttons: [{
                    text: translations.CANCEL,
                    type: 'button-stable button-clear'
                }]
            });
        });

        return defer.promise;
    }
}



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-color-selection/booking-color-selection.modal.js